"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { style: { "max-height": "40vh", "overflow": "scroll" } };
const _hoisted_2 = { key: 0 };
const _hoisted_3 = { class: "the-note" };
const _hoisted_4 = { key: 1 };
const _hoisted_5 = { class: "the-note" };
const _hoisted_6 = { key: 2 };
const _hoisted_7 = {
    key: 0,
    class: "the-note"
};
const _hoisted_8 = { class: "the-top-right-buttons the-navigation-buttons" };
const vue_3 = require("vue");
const map_config_1 = __importDefault(require("../../../../config/map.config"));
const vue_map_sdk_1 = require("@xenodrive/vue-map-sdk");
const LoadPage_vue_1 = __importDefault(require("@/components/LoadPage.vue"));
const vue_basic_ui_1 = require("@xenodrive/vue-basic-ui");
const BssMovementToggleListButton_vue_1 = __importDefault(require("@/components/BssMovementToggleListButton.vue"));
const BssMovementNaviationIcons_vue_1 = __importDefault(require("@/components/BssMovementNaviationIcons.vue"));
const BssMovementConfig_vue_1 = __importDefault(require("@/components/BssMovementConfig.vue"));
const BssMapLandmarkInfobox_vue_1 = __importDefault(require("@/components/BssMapLandmarkInfobox.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'MapLandmark',
    props: {
        url: {},
        latitude: {},
        longitude: {},
        mapZoom: {}
    },
    setup(__props, { expose: __expose }) {
        const props = __props;
        function onload() {
            window.initialize();
            window.$('body').trigger('bss:onload');
        }
        const query = (0, vue_3.computed)(() => {
            const search = new URLSearchParams(location.search);
            return '?' + search.toString();
        });
        const messages = (0, vue_3.reactive)({});
        const showMenu = (0, vue_3.ref)(true);
        const mapCenter = (0, vue_3.ref)([137.333872222, 38.0849725]);
        const landmarks = (0, vue_3.ref)({});
        const popups = (0, vue_3.ref)({});
        const mode = (0, vue_3.ref)('address_search');
        (0, vue_3.watch)(mode, () => {
            const url = new URL(location.href);
            url.searchParams.set('mode', mode.value);
            location.href = url.toString();
        });
        function closePopup(popup) {
            var _a, _b;
            if (!popup)
                return;
            const key = (_a = popup.id) !== null && _a !== void 0 ? _a : (_b = Object.entries(popups.value).find(([_k, v]) => v === popup)) === null || _b === void 0 ? void 0 : _b[0];
            if (key) {
                delete popups.value[key];
            }
        }
        function openPopup(popup) {
            var _a;
            if (!popup)
                return;
            const key = (_a = popup === null || popup === void 0 ? void 0 : popup.id) !== null && _a !== void 0 ? _a : 'none';
            popups.value[key] = popup;
            mapCenter.value = (0, vue_map_sdk_1.parseLngLat)(popup.coordinate).toCoordinate();
        }
        function togglePopup(popup) {
            var _a;
            if (!popup)
                return;
            if (popups.value[(_a = popup === null || popup === void 0 ? void 0 : popup.id) !== null && _a !== void 0 ? _a : ''])
                closePopup(popup);
            else
                openPopup(popup);
        }
        const clusterMarkers = (0, vue_3.ref)([]);
        const clusterPopupAnchor = (0, vue_3.ref)(undefined);
        const clusterPopup = (0, vue_3.ref)(false);
        function onClusterClicked(e) {
            if (e.markers && e.markers.length > 0) {
                clusterMarkers.value = e.markers;
                clusterPopupAnchor.value = [e.clientX, e.clientY];
                clusterPopup.value = true;
            }
        }
        function onMarkerClicked(e) {
            if (e.markers && e.markers.length === 1) {
                togglePopup(e.markers[0]);
                return;
            }
            onClusterClicked(e);
        }
        (0, vue_3.provide)('messages', messages);
        __expose({
            init(options) {
                Object.assign(messages, options.messages);
            },
            resizeMap() {
                var _a, _b;
                const parentArea = this.parent().first();
                if (!parentArea)
                    return;
                this.height((_a = parentArea.height()) !== null && _a !== void 0 ? _a : 0);
                this.width((_b = parentArea.width()) !== null && _b !== void 0 ? _b : 0);
            },
            setMapData(data) {
                landmarks.value = Object.fromEntries(data.landmarks.map((v) => [
                    String(v.id),
                    {
                        id: `landmark:${v.id}`,
                        coordinate: map_config_1.default.fromTokyo(v.point),
                        icon: 'icon_event_default',
                        direction: 0,
                        data: Object.assign(Object.assign({}, v), { point_w: map_config_1.default.fromTokyo(v.point) }),
                    },
                ]));
            },
            resetMap() { },
            showRightareaButton() { },
            openInfoboxLandmark(type, rowId) {
                var _a;
                openPopup((_a = landmarks.value) === null || _a === void 0 ? void 0 : _a[rowId]);
            },
            closeInfoboxLandmark(type, rowId) {
                var _a;
                closePopup((_a = landmarks.value) === null || _a === void 0 ? void 0 : _a[rowId]);
            },
            closeInfoboxLandmarkAll() {
                popups.value = {};
            },
            refreshMarkerLandmark() { },
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                (0, vue_2.createVNode)((0, vue_2.unref)(map_config_1.default).Map, {
                    "zoom-control": "left-top:1rem,5rem",
                    "scale-line": "",
                    center: mapCenter.value,
                    "onUpdate:center": _cache[3] || (_cache[3] = ($event) => ((mapCenter).value = $event)),
                    onClick: _cache[4] || (_cache[4] = ($event) => (popups.value = {}))
                }, {
                    default: (0, vue_2.withCtx)(() => [
                        (0, vue_2.createVNode)((0, vue_2.unref)(map_config_1.default).Markers, {
                            markers: landmarks.value,
                            onClick: (0, vue_2.withModifiers)(onMarkerClicked, ["stop"])
                        }, null, 8, ["markers"]),
                        (0, vue_2.createVNode)((0, vue_2.unref)(vue_basic_ui_1.Dropdown), {
                            active: clusterPopup.value,
                            "onUpdate:active": _cache[0] || (_cache[0] = ($event) => ((clusterPopup).value = $event)),
                            "popup-anchor": clusterPopupAnchor.value,
                            "no-trigger": ""
                        }, {
                            default: (0, vue_2.withCtx)(() => [
                                (0, vue_2.createVNode)((0, vue_2.unref)(vue_basic_ui_1.DropdownLabel), null, {
                                    default: (0, vue_2.withCtx)(() => _cache[5] || (_cache[5] = [
                                        (0, vue_2.createTextVNode)("候補選択", -1)
                                    ])),
                                    _: 1,
                                    __: [5]
                                }),
                                (0, vue_2.createElementVNode)("div", _hoisted_1, [
                                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(clusterMarkers.value, (v) => {
                                        return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)((0, vue_2.unref)(vue_basic_ui_1.DropdownItem), {
                                            key: v.id,
                                            onClick: ($event) => {
                                                clusterPopup.value = false;
                                                openPopup(v);
                                            }
                                        }, {
                                            default: (0, vue_2.withCtx)(() => [
                                                (v.data.search_type == 2)
                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_2, [
                                                        (0, vue_2.createElementVNode)("div", null, "〒" + (0, vue_2.toDisplayString)(v.data.zipcode), 1),
                                                        (0, vue_2.createElementVNode)("div", _hoisted_3, (0, vue_2.toDisplayString)(v.data.address), 1)
                                                    ]))
                                                    : (v.data.facility_name)
                                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_4, [
                                                            (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)(v.data.facility_name), 1),
                                                            (0, vue_2.createElementVNode)("div", _hoisted_5, (0, vue_2.toDisplayString)(v.data.address), 1)
                                                        ]))
                                                        : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_6, [
                                                            (v.data.zipcode)
                                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_7, "〒" + (0, vue_2.toDisplayString)(v.data.zipcode), 1))
                                                                : (0, vue_2.createCommentVNode)("", true),
                                                            (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)(v.data.address), 1)
                                                        ]))
                                            ]),
                                            _: 2
                                        }, 1032, ["onClick"]));
                                    }), 128))
                                ])
                            ]),
                            _: 1
                        }, 8, ["active", "popup-anchor"]),
                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(popups.value, (popup, idx) => {
                            return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)((0, vue_2.unref)(map_config_1.default).Popup, {
                                key: idx,
                                center: popup === null || popup === void 0 ? void 0 : popup.coordinate,
                                onClose: ($event) => (closePopup(popup)),
                                style: { "width": "max-content", "max-height": "30vh" }
                            }, {
                                default: (0, vue_2.withCtx)(() => [
                                    (0, vue_2.createVNode)(BssMapLandmarkInfobox_vue_1.default, {
                                        data: popup.data
                                    }, null, 8, ["data"])
                                ]),
                                _: 2
                            }, 1032, ["center", "onClose"]));
                        }), 128)),
                        (0, vue_2.createVNode)((0, vue_2.unref)(map_config_1.default).SidePanel, {
                            show: showMenu.value,
                            side: "right",
                            style: { "width": "40vw", "background": "white", "overflow": "auto" }
                        }, {
                            default: (0, vue_2.withCtx)(() => [
                                (0, vue_2.createVNode)((0, vue_2.unref)(vue_basic_ui_1.ResizeHandle), { orientation: "vertical" }),
                                (0, vue_2.createVNode)((0, vue_2.unref)(vue_basic_ui_1.SidePanelContainer), null, {
                                    default: (0, vue_2.withCtx)(() => [
                                        (0, vue_2.createVNode)(LoadPage_vue_1.default, {
                                            url: props.url,
                                            query: query.value,
                                            onLoad: onload
                                        }, null, 8, ["url", "query"])
                                    ]),
                                    _: 1
                                })
                            ]),
                            _: 1
                        }, 8, ["show"]),
                        (0, vue_2.createVNode)(BssMovementNaviationIcons_vue_1.default, {
                            modelValue: mode.value,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((mode).value = $event))
                        }, null, 8, ["modelValue"]),
                        (0, vue_2.createElementVNode)("div", _hoisted_8, [
                            (0, vue_2.createVNode)(BssMovementConfig_vue_1.default),
                            (0, vue_2.createVNode)(BssMovementToggleListButton_vue_1.default, {
                                modelValue: showMenu.value,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((showMenu).value = $event))
                            }, null, 8, ["modelValue"])
                        ])
                    ]),
                    _: 1
                }, 8, ["center"]),
                _cache[6] || (_cache[6] = (0, vue_2.createElementVNode)("div", {
                    class: "modal fade",
                    id: "loading_point-setting-modal",
                    "aria-hidden": "true"
                }, [
                    (0, vue_2.createElementVNode)("div", { class: "modal-dialog modal-lg position-center" }, [
                        (0, vue_2.createElementVNode)("div", { class: "modal-content text-left" })
                    ])
                ], -1))
            ], 64));
        };
    }
});
